import { useQuery } from '@tanstack/react-query';
import { MaterialCatalog } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { MATERIAL_CATALOG_QUERY_KEY } from './useMaterialCatalog';

export const useMaterialCatalogByCalculatorType = (
  calculatorType: string | undefined,
) => {
  return useQuery<MaterialCatalog[], Error>({
    queryKey: [...MATERIAL_CATALOG_QUERY_KEY, 'byCalculatorType', calculatorType],
    queryFn: async () => {
      if (!calculatorType) return [];
      return await warehouseService.getMaterialCatalogByCalculatorType(calculatorType);
    },
    enabled: !!calculatorType,
    staleTime: 5 * 60 * 1000,
  });
};
